import {css} from '@emotion/core';
import styled from '@emotion/styled';
import { black, lightBlue } from '@css/constants';
import { FontNormal } from '@css/fonts';
import { fontSize } from "@css/styles";

export const QuestionContainer = styled('div')(css`
  margin: 0;
`);

export const HelpText = styled('p')(css`
  ${FontNormal(500)}
  ${fontSize(14)};
  color: ${black};
  position: relative;
  padding-bottom: 4px;
`);

export const LegalText = styled('p')(css`
  ${FontNormal(400)}
  ${fontSize(12)};

  color: ${black};
  margin-top: 6px;

  a {
    color: ${lightBlue};
  }
`);

export const TitleText = styled('label')<{ isRequired: boolean }>(props => css`
  ${FontNormal(600)}
  ${fontSize(16)};

  display: block;
  position: relative;
  padding-bottom: 5px;

  text-align: left;
  color: ${black};

  &::after {
    /* content: ${props.isRequired ? '"*"' : 'none'}; */
    display: inline-block;
  }
`);

export const HiddenLabel = styled('label')(css`
  height: 1px;
  width: 1px;
  left: -10000px;
  overflow: hidden;
  position: absolute;
`);
